import { createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  originatorLocationProductOriginsList: [],
  pending: false,
};

const reducers = {
  fetchOriginatorLocationProductOriginsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchOriginatorLocationProductOriginsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchOriginatorLocationProductOriginsSuccess(state, { payload }) {
    return R.assoc('originatorLocationProductOriginsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'originatorLocationProductOrigins',
  reducers,
});

const {
  fetchOriginatorLocationProductOriginsPending,
  fetchOriginatorLocationProductOriginsSuccess,
  fetchOriginatorLocationProductOriginsError,
} = actions;

export const getOriginatorLocationProductOriginsError = state =>
  state.pto.originatorLocationProductOrigins.error;

// Actions
let fetchController;
export function fetchOriginatorLocationProductOrigins(params = {}) {
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;
  return dispatch => {
    dispatch(fetchOriginatorLocationProductOriginsPending(true));
    const formattedParams = qs.stringify(params, {
      allowDots: true,
      encode: false,
    });

    return http
      .get(
        `/product-transfer-orders/get-unique-originator-location-product-origins?${formattedParams}`,
        { signal }
      )
      .then(res => {
        dispatch(fetchOriginatorLocationProductOriginsError(''));
        dispatch(fetchOriginatorLocationProductOriginsSuccess(res.data));
        dispatch(fetchOriginatorLocationProductOriginsPending(false));
      })
      .catch(error => {
        if (error?.response?.data?.title) {
          dispatch(
            createSnack({
              message: error.response.data.title,
              options: { variant: 'error' },
            })
          );
        }
      });
  };
}

export default reducer;
